<template>
  <HelperViewStatus
    class="handle-error"
    title="Houve um problema ao carregar as informações"
    description="Aguarde um momento e tente novamente."
    button-label="Tentar novamente"
    status="alert"
    @click="fetchInitialData"
  />
</template>

<script lang="ts" setup>
import { inject } from 'vue';

import { HelperViewStatus } from '@warrenbrasil/nebraska-web';

const fetchInitialData = inject('fetchInitialData', () => ({}));
</script>

<style lang="less" scoped>
.handle-error {
  margin: 0 auto;
  height: calc(100vh - 128px);
  justify-content: center;
}
</style>
